import { render } from "./KeypointQ.vue?vue&type=template&id=7920fd80&scoped=true"
import script from "./KeypointQ.vue?vue&type=script&lang=js"
export * from "./KeypointQ.vue?vue&type=script&lang=js"

import "./KeypointQ.vue?vue&type=style&index=0&id=7920fd80&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7920fd80"]])

export default __exports__